/**
 * @generated SignedSource<<08db02814af14c132f8feffd11429ac7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditEmailTemplateScreen_Query$variables = {
  id: string;
};
export type EditEmailTemplateScreen_Query$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"EditEmailTemplateScreen_EmailTemplateFragment">;
  } | null | undefined;
};
export type EditEmailTemplateScreen_Query = {
  response: EditEmailTemplateScreen_Query$data;
  variables: EditEmailTemplateScreen_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditEmailTemplateScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "EditEmailTemplateScreen_EmailTemplateFragment"
              }
            ],
            "type": "PersonalizedEmailTemplate",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditEmailTemplateScreen_Query",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EmailTemplate",
                "kind": "LinkedField",
                "name": "template",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "subject",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previewText",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "body",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "variables",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "PersonalizedEmailTemplate",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "fe8123046989e2dc16a0872d87eab208",
    "id": null,
    "metadata": {},
    "name": "EditEmailTemplateScreen_Query",
    "operationKind": "query",
    "text": "query EditEmailTemplateScreen_Query(\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ... on PersonalizedEmailTemplate {\n      ...EditEmailTemplateScreen_EmailTemplateFragment\n    }\n    id\n  }\n}\n\nfragment EditEmailTemplateScreen_EmailTemplateFragment on PersonalizedEmailTemplate {\n  id\n  template {\n    key\n    subject\n    previewText\n    body\n    variables\n  }\n}\n"
  }
};
})();

(node as any).hash = "75c196477c4bb67e2aa622be2b978af4";

export default node;
